import { createMuiTheme } from "@material-ui/core";
const defaultTheme = createMuiTheme();

export default {
  overrides: {
    // <Link> component styles
    MuiLink: {
      root: {
        cursor: "pointer",
      },
      underlineHover: {
        "&:hover": {
          textDecoration: "none",
        },
      },
    },
    // <TableCell> component styles
    MuiTableCell: {
      root: {
        borderBottom: "1px solid " + "#0F2C2A",
      },
    },
    // <Paper> component styles
    MuiPaper: {
      root: {
        padding: 16,
        backgroundColor: "#261758",
      },
      elevation1: {
        boxShadow: "none",
      },
      rounded: {
        borderRadius: 12,
      },
    },
    MuiTypography: {
      root: {
        "& pre": {
          whiteSpace: "normal",
        },
        "& em": {
          display: "block",
          color: "#3CBA68",
        },
      },
      gutterBottom: {
        marginBottom: "0.5em",
      },
    },
    MuiTableContainer: {
      root: {
        width: "100%",
        [defaultTheme.breakpoints.down("sm")]: {
          width: "calc(100vw - 48px)",
        },
        [defaultTheme.breakpoints.down("xs")]: {
          width: "calc(100vw - 32px)",
        },
      },
    },
  },
};
